module.exports = __webpack_public_path__ + "img/AT.5265df05.svg";